/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-all-blocks-of-client'),
        dataTables_buttons = [
            {
                extend: 'excel',
                text: 'Export as Excel',
                exportOptions: {
                    columns: '.data-export'
                }
            }
        ],
        $clientId = $datatable.data('client'),
        $showActions = $('.js-show-actions'),
        columns = [
            {data: 'nameLink', name: 'name', className: 'data-export'},
            {data: 'number_of_properties', name: 'number_of_properties', orderable: false, searchable: false, className: 'data-export'},
        ],
        actionColumn =  {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" };

    if($showActions.length > 0){
        columns.push(actionColumn);
    }

    $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
	    "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": helper.getOrigin() + "/api/clients/" + $clientId + "/blocks",
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": columns
    });
});
